import { render, staticRenderFns } from "./AnnouncementLink.vue?vue&type=template&id=295291bf&scoped=true&"
import script from "./AnnouncementLink.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementLink.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementLink.vue?vue&type=style&index=0&id=295291bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295291bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VItem,VTooltip})
